import React, { useState,useEffect } from "react";
import "./arjunpage.css";


const ArjunPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const[link,setLink]=useState(null);

    useEffect(() => {
    fetch("/data.json")  
      .then(res => res.json())
      .then(data => setLink(data))
      .catch(err => console.error("Failed to load data.json:", err));
  }, []);
  const youtubeUrl = link?.["arjun-youtubelink"];


  const articlesImages = [
    "/arjunimages/image1.jpeg",
    "/arjunimages/image2.jpeg",
    "/arjunimages/image3.jpeg",
    "/arjunimages/image4.jpeg",
    "/arjunimages/image5.jpeg",
    "/arjunimages/image6.jpeg",
    "/arjunimages/image7.jpeg",
  ];

  return (
<>
      <div className="arjun-page">
        <div className="arjun-content">

          {/* LEFT SIDE */}
          <div className="arjun-left">
            <div
              className="ar-video-container"
              onClick={() => window.open(youtubeUrl, "_blank")}
            >
              <img
                src="/arjunthumbnail.jpeg"
                alt="Arjun Video"
                className="ar-video-thumbnail"
              />
              <div className="ar-play-button">&#9658;</div>
            </div>

            <div className="arjun-text">
              <h1>ASC Arjun – A Robocop</h1>
              <p>
            ASC Arjun – Robocop is invented, designed, manufactured, and implemented by <b>Robocoupler Pvt. Ltd.</b>, Visakhapatnam, Andhra Pradesh,
                in close collaboration with the Railway Protection Force (RPF), and has been successfully deployed for East Coast Railway.
            </p>
               <p>
                ASC Arjun is a semi-autonomous robotic system focused on Safety, Security, and Surveillance (SSS), integrating advanced Robotics 
                and Artificial Intelligence (AI) for real-time monitoring, obstacle detection, autonomous navigation, and intelligent alert mechanisms.
                It enhances crowd monitoring, platform patrolling, and situational awareness, supporting RPF personnel within railway premises.
                This opportunity was extended to Robocoupler Pvt. Ltd. by Inspector General (RPF)<b>Shri Alok Bohra</b> and Divisional Railway Manager <b>Shri Lalit Bohra</b>, 
                in the esteemed presence of Senior Divisional Security Commandant (RPF) <b>Shri A. K. Dubey.</b>
            </p>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="arjun-right">

          <div className="ar-tab-buttons">
          <button className="active">
            Articles & Testimonals
          </button>
        </div>

            {/* IMAGES LIST */}
            <div className="right-scroll-wrapper">
            <div className="right-scroll-track">
              {articlesImages.concat(articlesImages).map((img, index) => (
                <img key={index} src={img} alt=""onClick={() => setSelectedImage(img)} />
              ))}
            </div>
          </div>
          </div>

        </div>
      </div>


      {selectedImage && (
        <div
          className="image-modal-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className="arjun-modal-close"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </span>

            <img src={selectedImage} alt="Preview" />
          </div>
        </div>
      )}

</>
      

  );
  
};

export default ArjunPage;